import * as React from 'react'
import type { InputBaseComponentProps } from '@mui/material'
import { PatternFormat } from 'react-number-format'

/**
 * Based on this MUI5 Example: [Create shared environment handling lib](https://mui.com/material-ui/react-text-field/#integration-with-3rd-party-input-libraries)
 * */
export const CustomPhoneInput = React.forwardRef<HTMLElement, InputBaseComponentProps>(
    function CustomPhoneInput(props, ref) {
        const { defaultValue, name, onChange, ...rest } = props
        return (
            <PatternFormat
                {...rest}
                format="+1 (###) ###-####"
                getInputRef={ref}
                allowEmptyFormatting
                mask="_"
                onValueChange={({ value }) => {
                    const eventLike = {
                        target: { name, value },
                    } as React.ChangeEvent<HTMLInputElement>
                    onChange?.(eventLike)
                }}
                defaultValue={Array.isArray(defaultValue) ? defaultValue[0] : defaultValue}
            />
        )
    },
)
